import {
  StableAppDetailsPage,
  TestingAppDetailsPage,
} from "fleet/controller/application/connected-details";
import { ConnectedInstalledAppsListPage } from "fleet/controller/application/connected-installed-list";
import { ConnectedStoreAppMainPage } from "fleet/controller/application/connected-store-page";
import { ConnectedAppUpload } from "fleet/controller/application/connected-upload";
import React from "react";
import { PrivateRoute } from "ui/private-route";

function renderApplicationsRoutes() {
  return [
    <PrivateRoute
      exact
      path="/applications"
      key="applications-list"
      component={ConnectedInstalledAppsListPage}
    />,
    <PrivateRoute
      exact
      path="/applications/upload"
      key="applications-upload"
      component={ConnectedAppUpload}
    />,
    <PrivateRoute
      exact
      path="/applications/store"
      key="applications-store"
      component={ConnectedStoreAppMainPage}
    />,
    <PrivateRoute
      exact
      path="/applications/:id"
      key="applications-details"
      component={StableAppDetailsPage}
    />,
    <PrivateRoute
      exact
      path="/applications/:id/testing"
      key="applications-details-testing"
      component={TestingAppDetailsPage}
    />,
  ];
}

export { renderApplicationsRoutes };
